import { Injectable } from '@angular/core';
import { Toast } from 'bootstrap';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastElement: HTMLElement | null = null;
  private toastTimeout: any = null;

  constructor() {}

  private ensureToastInBody() {
    this.toastElement = document.getElementById('liveToast');
    if (this.toastElement) {
      const container = (this.toastElement.closest('.toast-container') || this.toastElement) as HTMLElement;
      if (container) {
        container.style.position = 'fixed';
        container.style.top = '20px';
        container.style.right = '20px';
        container.style.left = 'auto';
        container.style.bottom = 'auto';
        container.style.zIndex = '2147483647';
      }
      const targetParent = document.body;

      if (container && container.parentElement !== targetParent) {
        targetParent.appendChild(container);
      }
    }
  }

  showSuccess(message: any) {
    let msgStr = typeof message === 'object' ? (message?.message || message?.msg || 'Request successful') : message;
    if (msgStr == 'successful') {
      msgStr = 'Request successful';
    }
    this.showToast('Success', msgStr || 'Request successful', 'success');
  }

  showError(message: any) {
    let msgStr = message;
    if (Array.isArray(message)) {
      msgStr = message.join('\n');
    } else if (typeof message === 'object' && message !== null) {
      const errBody = message?.error || message;
      const rawMsg = errBody?.message || errBody?.msg || message?.message || message?.msg;
      if (Array.isArray(rawMsg)) {
        msgStr = rawMsg.join('\n');
      } else if (typeof rawMsg === 'string' && !rawMsg.includes('Http failure response')) {
        msgStr = rawMsg;
      } else if (typeof message.error === 'string') {
        msgStr = message.error;
      } else {
        msgStr = JSON.stringify(message);
      }
    }
    this.showToast('Error', msgStr || 'Request failed', 'danger');
  }

  showToast(title: string, message: string, type: string) {
    this.ensureToastInBody();
    if (!this.toastElement) {
      this.toastElement = document.getElementById('liveToast');
    }

    if (this.toastElement) {
      this.toastElement.classList.remove('text-bg-success', 'text-bg-danger', 'text-bg-warning', 'text-bg-info', 'hide');
      this.toastElement.classList.add(`text-bg-${type}`, 'show');
      this.toastElement.style.display = 'block';
      this.toastElement.style.opacity = '1';
      this.toastElement.style.visibility = 'visible';

      const header = this.toastElement.querySelector('.toast-header strong');
      if (header) (header as HTMLElement).innerText = title;
      const body = this.toastElement.querySelector('.toast-body');
      if (body) (body as HTMLElement).innerText = message;

      if (this.toastTimeout) {
        clearTimeout(this.toastTimeout);
      }

      try {
        const bsToast = Toast.getOrCreateInstance(this.toastElement, { autohide: true, delay: 4000 });
        bsToast.show();
      } catch (e) {
        console.warn('Bootstrap toast fallback:', e);
      }

      this.toastTimeout = setTimeout(() => {
        this.hideToast();
      }, 4000);
    }
  }

  hideToast() {
    if (!this.toastElement) {
      this.toastElement = document.getElementById('liveToast');
    }
    if (this.toastElement) {
      this.toastElement.classList.remove('show');
      this.toastElement.style.opacity = '0';
      setTimeout(() => {
        if (this.toastElement && !this.toastElement.classList.contains('show')) {
          this.toastElement.style.display = 'none';
          this.toastElement.style.visibility = 'hidden';
        }
      }, 300);
    }
  }
}
